import React from 'react';
import { NavLink } from 'react-router-dom';
import { BookOpen, LayoutDashboard, ShoppingBag, User, Wrench } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const navItems = [
  { label: 'Home', icon: LayoutDashboard, path: '/dashboard' },
  { label: 'Repairs', icon: Wrench, path: '/dashboard/repairs' },
  { label: 'Shop', icon: ShoppingBag, path: '/shop' },
  { label: 'Courses', icon: BookOpen, path: '/dashboard/courses' },
  { label: 'Profile', icon: User, path: '/dashboard/profile' },
];

export const MobileBottomNav: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return null;

  return (
    <nav
      aria-label="Mobile navigation"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-5 border-t border-[rgb(var(--border))] bg-[rgb(var(--card))]/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden"
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/dashboard' || item.path === '/shop'}
            className={({ isActive }) =>
              `flex min-h-16 flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors ${
                isActive ? 'text-primary' : 'text-[rgb(var(--light-secondary))]'
              }`
            }
          >
            <Icon className="h-5 w-5" aria-hidden="true" />
            <span>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};
